











































































































































































/*

To do for paid pages:
1. Update page object for paid feature:
{
    ...,
    Paid: boolean, // whether the page is paid or not
    AvailableInPlans: string[], // list of plan IDs that have access to the page (
}

2. in page detail view show when changing visibility open modal with page setting (like in events)
3. preserve share in post prompt when changing visibility from private/community to paid and show message that users who don't have access won't see the post and won't be able to access the page. also show required membership in the prompt.
*/

import Vue from 'vue';
import axios from 'axios';
import i18n from 'vue-i18n';

import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';

import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';

import CoRules from '@/components/Organisms/co-rules/CoRules.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoCollapsible from '@/components/Molecules/co-collapsible/CoCollapsible.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoMultiSelect from '@/components/Molecules/co-multiselect/CoMultiSelect.vue';

import { UserFilterOption } from '@/components/Organisms/co-user-filter/models';

import EventBus from '../../eventBus';

export default {
    components: { CoCheckbox, CoFormGroup, CoSelect, CoInput, CoText, CoRules, CoMultiSelect },
    i18n: {
        messages: {
            en: {
                pagecreateinfo: 'You can always change this later.',
                pagenameplaceholder: "Your @:labels.page's name",
                joinpermissions: 'How can other members join?',
                joininviteonly: 'By Invitation Only',
                joinapprovalbased: 'Members can request to join',
                joinopen: 'Everyone can join',

                visibility: 'Who can see this page?',
                private: 'Private, only visible to members of this page',
                community: 'Visible to everyone in the community',

                whocanfollow: 'Anyone who can see the page can follow it.',
                rolesexplained1: `Owners can edit and delete the page and can add and remove contributors.`,
                rolesexplained2: `Contributors can publish posts on the page.`,
                rolesexplained3: `Followers receive notifications about every post on the page.`,
            },
            de: {
                pagecreateinfo: 'Du kannst dies jederzeit anpassen.',
                pagenameplaceholder: 'Name deiner @:labels.page',
                joinpermissions: 'Wie können andere Mitglieder beitreten?',
                joininviteonly: 'Nur durch Hinzufügen',
                joinapprovalbased: 'Mitglieder können Beitrittsanfragen stellen',
                joinopen: 'Alle können beitreten',

                visibility: 'Wer kann diese Seite sehen?',
                private: 'Privat, nur sichtbar für Mitglieder dieser Seite',
                community: 'Sichtbar für alle in der Community',

                whocanfollow: 'Wer die Seite sehen kann, kann ihr folgen.',
                rolesexplained1: `Inhaber:innen können die Seite bearbeiten und löschen und können Mitwirkende hinzufügen und entfernen.`,
                rolesexplained2: `Mitwirkende können Beiträge auf der Seite veröffentlichen.`,
                rolesexplained3: `Follower*innen erhalten Benachrichtigungen über jeden Beitrag auf der Seite.`,
            },
        },
    },
    name: 'CreateProject',
    data() {
        return {
            isAdmin: this.$store.state.me.Permissions && this.$store.state.me.Permissions.includes('space_admin'),
            title: '',
            channels: [],
            preselectedChannelSlug: this.$route.query.channel,
            channel: null,
            // join strategy
            inviteOnly: false,
            approvalBased: true,
            open: false,

            // use case based visibility
            private: true,
            community: false,
            paid: false,

            loading: false,

            visibilityRules: {
                ConditionsGroups: [],
                CombineWithOR: false,
            },
            planOptions: [] as UserFilterOption[],
            selectedPlans: [] as UserFilterOption[],
        };
    },
    watch: {
        channels(val) {
            // Only preselect a channel when creation was opened from that channel.
            if (this.preselectedChannelSlug) {
                const selected = val.find((element) => element.Slug === this.preselectedChannelSlug);
                this.channel = selected ? { Name: selected.Value, Value: selected.ID } : null;
            }
        },
        private(val) {
            if (val) {
                this.community = false;
                this.paid = false;
            }
        },

        community(val) {
            if (val) {
                this.private = false;
                this.paid = false;
            }
        },

        someUsers(val) {
            if (val) {
                this.private = false;
                this.community = false;
                this.paid = false;
            }
        },
        paid(val) {
            if (val) {
                this.private = false;
                this.community = false;
            }
        },

        inviteOnly(val) {
            if (val) {
                this.approvalBased = false;
                this.open = false;
            }
        },
        approvalBased(val) {
            if (val) {
                this.inviteOnly = false;
                this.open = false;
            }
        },
        open(val) {
            if (val) {
                this.inviteOnly = false;
                this.approvalBased = false;
            }
        },
    },
    computed: {
        // A page only needs a title; its channel can be assigned later.
        canICreatePage() {
            return this.title.trim() !== '';
        },
        channelsList() {
            return this.channels.map((element) => ({ Value: element.ID, Name: element.Value }));
        },
        me() {
            return this.$store.state.me;
        },
    },
    mounted() {
        // focus on title input
        this.$refs.title.focus();
        this.getAllPlans();
        this.$nextTick(() => {
            // Code that will run only after the
            // entire view has been rendered
            this.listchannels();
        });
    },
    methods: {
        discard() {
            if (window.history.length > 2) {
                this.$router.go(-1);
            } else {
                this.$router.push('/');
            }
        },
        buildPageSections() {
            const sections = [];

            // Paid pages must start with a paywall divider even when no other sections exist yet.
            if (this.paid) {
                sections.push({
                    Type: 4,
                    Content: '',
                });
            }

            return sections;
        },
        selectChannel(channel) {
            this.channel = channel || null;
        },

        listchannels() {
            this.channels = [];
            axios({
                method: 'GET',
                url: '/project/project-type/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response.data && response.data.objects && response.data.objects.length !== 0) {
                        if (this.isAdmin) {
                            this.channels = response.data.objects.map((element) => element.object);
                        } else {
                            this.channels = response.data.objects
                                .filter((element) => element.object.AddPagesPermission !== 1)
                                .map((element) => element.object);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        hasHistory() {
            return window.history.length > 2;
        },

        emitEventToIntercom() {
            if (this.$store.state.me.Permissions && this.$store.state.me.Permissions.includes('space_admin')) {
                this.$intercom.trackEvent('created-project');
            }
        },

        postProject() {
            if (!this.canICreatePage) {
                return;
            }
            this.loading = true;

            const page = {
                Title: this.title,
                ChannelID: this.channel?.Value || '',
                UserID: this.$store.state.me.ID,
                Contributor: [this.$store.state.me.ID],
                Owner: [this.$store.state.me.ID],
                ImageURL: [],
                Sections: this.buildPageSections(),
                JoinStrategy: 1,
                Published: false,
                PublishedAt: 0,
                Paid: this.paid,
                AvailableInPlans: this.paid ? this.selectedPlans.map((option) => option.Value) : [],
            };

            if (this.inviteOnly) {
                page.JoinStrategy = 0;
            } else if (this.approvalBased) {
                page.JoinStrategy = 1;
            } else if (this.open) {
                page.JoinStrategy = 2;
            }

            if (this.community) {
                page.Published = true;
                page.PublishedAt = Math.floor(Date.now() / 1000);
            }

            if (page.Paid) {
                page.Published = true;
                page.PublishedAt = Math.floor(Date.now() / 1000);
            }

            axios({
                method: 'POST',
                url: '/project',
                data: page,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    EventBus.$emit('intercomTrackEvent', {
                        eventName: 'created-project',
                    });

                    setTimeout(() => {
                        this.emitEventToIntercom();

                        EventBus.$emit('INFO', {
                            Message: this.$t('labels.pagecreated'),
                            Details: null,
                        });

                        this.$router.push(`/page/${response.data.Slug}`);
                        EventBus.$emit('CONFETTI', {});
                    }, 300);
                })
                .catch((error) => {
                    console.log(error);
                    const message = {
                        Message: this.$t('labels.pagecreated'),
                        Details: null,
                    };
                    EventBus.$emit('ERROR', message);

                    this.loading = false;
                });
        },
        getAllPlans() {
            axios({
                method: 'GET',
                url: '/admin/plan/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const planList = response?.data?.Plans || [];
                    // Normalize plans for CoUserFilter so plan chips and plan filters share the same option shape.
                    this.planOptions = planList
                        .filter((plan) => plan?.ID && plan?.Name)
                        .map((plan) => ({
                            Name: plan.Name,
                            Value: plan.ID,
                        }));
                })
                .catch((error) => {
                    console.error('Error fetching plans:', error);
                });
        },
    },
};
